<section class="h5 d-flex flex-column flex-md-column flex-lg-row flex-xl-row gap-2">
    <strong class="mb-2">Step 6:</strong>
    <span class="fw-normal">Payment Method</span>
</section>
<p class="text-muted mb-4">
    <strong>One last step.</strong> Money can’t buy happiness, but it can buy heirloom tomatoes. Enter your payment
    info below to secure your spot on our farm-to-fridge list:
</p>

<form [formGroup]="svc.paymentForm" class="row g-4" novalidate>
    <div class="col-lg-7">
        <div class="row g-3">
            <div class="col-12 col-md-6">
                <label class="form-label small fw-medium">CARD NUMBER*</label>
                <div class="position-relative">
                    <input type="text" class="form-control pe-5" formControlName="cardNumber"
                        (input)="onCardNumberInput($event)" [class.is-invalid]="invalid('cardNumber')"
                        placeholder="0000 0000 0000 0000">
                    <img *ngIf="cardBrandIcon() as icon" [src]="icon" alt="brand" width="28" height="18"
                        class="position-absolute top-50 end-0 translate-middle-y me-3" />
                </div>
                <div class="text-danger small" *ngIf="invalid('cardNumber')">Card number is required.</div>
            </div>
            <div class="col-12 col-md-6">
                <label class="form-label small fw-medium">NAME ON CARD*</label>
                <input type="text" class="form-control" formControlName="billingName"
                    [class.is-invalid]="invalid('billingName')" placeholder="First and Last Name">
                <div class="text-danger small" *ngIf="invalid('billingName')">Name is required.</div>
            </div>
            <div class="col-6">
                <label class="form-label small fw-medium">EXPIRATION DATE*</label>
                <input type="text" class="form-control" formControlName="exp" placeholder="MM/YYYY" inputmode="numeric"
                    autocomplete="cc-exp" maxlength="7" (keydown)="onExpKeyDown($event)" (input)="onExpInput($event)"
                    (paste)="onExpPaste($event)" [class.is-invalid]="invalid('exp')">
                <ng-container *ngIf="invalid('exp')">
                    <div class="text-danger small" *ngIf="svc.paymentForm.get('exp')?.errors?.['pattern']; else expReq">
                        Expiration date must be in MM/YYYY format.
                    </div>
                    <ng-template #expReq>
                        <div class="text-danger small">Expiration date is required.</div>
                    </ng-template>
                </ng-container>
            </div>
            <div class="col-6">
                <label class="form-label small fw-medium">SECURITY CODE*</label>
                <input type="text" class="form-control" formControlName="cvc" placeholder="CVC"
                    [class.is-invalid]="invalid('cvc')" appOnlyNumber maxlength="4">
                <div class="text-danger small" *ngIf="invalid('cvc')">Security code is required.</div>
            </div>
            <div class="col-12">
                <hr>
            </div>
            <h4 class="col-12 m-0">Billing Address</h4>
            <div class="col-12 form-check m-0 mb-3 p-0">
                <mat-checkbox formControlName="billingAddressDifferent" color="primary" id="billingDifferentCheck" (change)="cdRef.markForCheck()">
                    My billing address is different from my delivery address
                </mat-checkbox>
            </div>

            <ng-container *ngIf="svc.paymentForm.get('billingAddressDifferent')?.value">
                <div class="col-12">
                    <label class="form-label small fw-medium">HOME ADDRESS*</label>
                    <input type="text" class="form-control" formControlName="billingAddress1"
                        [class.is-invalid]="invalid('billingAddress1')">
                    <div class="text-danger small" *ngIf="invalid('billingAddress1')">Address is required.</div>
                </div>
                <div class="col-12">
                    <label class="form-label small fw-medium">ADDRESS 2</label>
                    <input type="text" class="form-control" formControlName="billingAddress2">
                </div>
                <div class="col-md-6">
                    <label class="form-label small fw-medium">CITY*</label>
                    <input type="text" class="form-control" formControlName="billingCity"
                        [class.is-invalid]="invalid('billingCity')">
                    <div class="text-danger small" *ngIf="invalid('billingCity')">City is required.</div>
                </div>
                <div class="col-md-3">
                    <label class="form-label small fw-medium">STATE*</label>
                    <select class="form-select" formControlName="billingState"
                        [class.is-invalid]="invalid('billingState')">
                        <option value="" disabled>State</option>
                        <option *ngFor="let st of states()" [value]="st.id">{{ st.name }}</option>
                    </select>
                    <div class="text-danger small" *ngIf="invalid('billingState')">State is required.</div>
                </div>
                <div class="col-md-3">
                    <label class="form-label small fw-medium">ZIP CODE*</label>
                    <input type="text" class="form-control" formControlName="billingZip"
                        [class.is-invalid]="invalid('billingZip')" appOnlyNumber maxlength="5">
                    <div class="text-danger small" *ngIf="invalid('billingZip')">ZIP code is required.</div>
                </div>
            </ng-container>
            <div class="col-12">
                <hr>
            </div>
            <div class="col-12 form-check m-0 p-0">
                <mat-checkbox formControlName="terms" color="primary" id="termsCheck" (change)="cdRef.markForCheck()">
                    * I agree to the <a href="javascript:void(0)" [routerLink]="['/terms-and-conditions']"
                        target="_blank">Terms & Conditions</a>
                </mat-checkbox>
                <div class="text-danger small" *ngIf="invalid('terms')">Required</div>
            </div>

            <!-- Botón para procesar el pago -->
            <div class="col-12 mt-3">
                <button type="button" class="btn btn-primary btn-lg w-100" [disabled]="!svc.paymentForm.valid"
                    (click)="sendDataToANet()">
                    Complete Signup
                </button>
            </div>
        </div>
    </div>
    <div class="col-lg-5">
        <div class="summary-box border rounded p-3 small">
            <h6 class="fw-bold mb-3">Your Subscription(s)</h6>

            <section class="summary-box-content">
                <!-- Produce Boxes seleccionados -->
                @if (isProduceBoxesLoading()) {
                <app-section-loader [message]="'Loading produce boxes...'"
                    [loaderSize]="LoaderSizeEnum.SM"></app-section-loader>
                } @else {
                <div *ngIf="produceBoxes().length > 0" class="product-section">
                    <div *ngFor="let box of produceBoxes()" class="subscription-item mb-3">
                        <div class="d-flex align-items-start gap-3">
                            <!-- Product Image -->
                            <div class="product-image">
                                <img [src]="box.img" [alt]="box.name" (error)="onImageError($event)"
                                    class="img-fluid rounded" width="60" height="60">
                            </div>

                            <!-- Product Details -->
                            <div class="flex-grow-1">
                                <h6 class="mb-0 fw-bold text-dark">{{ box.name }}</h6>

                                <div class="d-flex align-items-center my-1 gap-2">
                                    <p class="text-muted small m-0 pe-2 border-end border-dark">{{ box.frequency }}</p>
                                    <p class="text-muted small m-0">{{ box.price ? (box.price |
                                        currency:'USD':'symbol':'1.2-2') : box.bundle?.priceRange ||
                                        box._signup?.meta?.priceRange || '$44.99-$55.99' }}</p>
                                    <i class="fas fa-info-circle text-dark small"
                                        ngbTooltip="The share price changes weekly based on contents but always stays within the listed range. You won’t be charged for items you remove."></i>
                                </div>


                                <button type="button" class="btn btn-link p-0 text-danger small fw-medium"
                                    (click)="removeProduceBox(box.id)">
                                    Remove
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                }

                <!-- Suscripciones extra seleccionadas -->
                @if (isExtraSubscriptionsLoading()) {
                <app-section-loader [message]="'Loading extra subscriptions...'"
                    [loaderSize]="LoaderSizeEnum.SM"></app-section-loader>
                } @else {
                <div *ngIf="extraSubscriptions().length > 0" class="product-section">
                    <div *ngFor="let sub of extraSubscriptions()" class="subscription-item mb-3">
                        <div class="d-flex align-items-start gap-3">
                            <!-- Product Image -->
                            <div class="product-image">
                                <img [src]="sub.img" [alt]="sub.name" (error)="onImageError($event)"
                                    class="img-fluid rounded" width="60" height="60">
                            </div>

                            <!-- Product Details -->
                            <div class="flex-grow-1">
                                <h6 class="mb-0 fw-bold text-dark">{{ sub.name }}</h6>

                                <div class="d-flex align-items-center my-1 gap-2">
                                    <p class="text-muted small m-0 pe-2 border-end border-dark">{{ sub.frequency }}</p>

                                    <p class="text-muted small m-0">{{ sub.price | currency:'USD':'symbol':'1.2-2' }}
                                    </p>
                                </div>


                                <button type="button" class="btn btn-link p-0 text-danger small fw-medium"
                                    (click)="removeExtraSubscription(sub.id)">
                                    Remove
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </section>


            <!-- Mensaje si no hay suscripciones seleccionadas -->
            <div *ngIf="produceBoxes().length === 0 && extraSubscriptions().length === 0" class="mb-3">
                <p class="small text-muted mb-0">No subscriptions selected</p>
            </div>

            <div class="alert alert-success py-2 mb-2 small">Great news! You'll get 50% off your first box!</div>
            <div class="alert alert-secondary py-2 small mb-0">We will not charge your credit card until your selected
                shipping date [{{deliveryDayText()}}]*.</div>
        </div>
    </div>
</form>